/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $(function() {
        $('.beefup').beefup();
   
   
   $(".itemcl").click(function(){
$(this).toggleClass("selected");
if($(this).hasClass("selected")){
 $(this).find('input').prop('checked', true); 
}else{
  $(this).find('input').prop('checked', false); 
}

})


jQuery(".accordion_head").on('click', function() {
    if (jQuery('.accordion_body').is(':visible')) {
      jQuery(".accordion_body").slideUp(300);
      jQuery(".plusminus").text('+');
    }
    if (jQuery(this).next(".accordion_body").is(':visible')) {
      jQuery(this).next(".accordion_body").slideUp(300);
      jQuery(this).children(".plusminus").text('+');
      jQuery(this).removeClass("active");
    } else {
      jQuery(this).next(".accordion_body").slideDown(300);
      jQuery(this).children(".plusminus").text('-');
      jQuery(this).addClass("active");
    }
  });
   
   
   $(".tab-content").slick({
   
     arrows: true,
            prevArrow:"<button type='button' class='slick-preva pull-left'></button>",
            nextArrow:"<button type='button' class='slick-nexta pull-right'></button>"
        
   
   })
   
   
   
   $('.tab-content').on('swipe', function(event, slick, direction){
  console.log(direction);
     console.log()
  // left
});
   
   $('.tab-content').on('afterChange', function(event, slick, currentSlide, nextSlide){
  var nsl=parseInt(currentSlide) + 1;
     
     console.log(nsl);
     $(".tab-buttons span").removeClass("active");
$("#content"+nsl).addClass("active");
     
});
   
   
   
   
   
   $("#content1").addClass("active");
   
   
   
   $(".tab-buttons span").click(function(){
$(".tab-buttons span").removeClass("active");
$(this).addClass("active");
     var tid=$(this).attr("data-id");
      tid=parseInt(tid)-1;
     $(".tab-content").slick('slickGoTo',tid);
})
   
   
   
$(".cltit").each(function(){
var xx=$(this).attr("data-sl");
  
$("."+xx).slick({

 slidesToShow: 4,
 slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-preva pull-left'></button>",
            nextArrow:"<button type='button' class='slick-nexta pull-right'></button>",
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  
});   
  
});
   
   $(".cltit").click(function(){
var xx=$(this).attr("data-sl");
console.log(xx);
  $(".cltit").removeClass("active");
  $(this).addClass("active");
$(".cbslides").hide();
$("."+xx).show();
  
  $(".cbslides").slick("unslick");

$("."+xx).slick({

 slidesToShow: 4,
 slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-preva pull-left'></button>",
            nextArrow:"<button type='button' class='slick-nexta pull-right'></button>",
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  
});
})
   
   
   
   $(".cbslides").hide();$(".cbslides:first-child").show();
   
   
   
   $(".col1").addClass("active");
});


 var worker = function(){
              
              var pp= document.getElementsByClassName('ProductForm__AddToCart');
              pp[0].classList.toggle("prodadded");
             
};